import {
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  createMuiTheme,
  MuiThemeProvider,
  TextField,
  Tooltip,
  Typography,
  Card as CardMaterial,
  CardMedia,
  Modal,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  AddComment,
  AddPhotoAlternate,
  Delete,
  Launch,
  NoteAdd,
  RateReview,
  Visibility,
  Create,
  VerifiedUser,
  KeyboardArrowUp,
  KeyboardArrowDown,
  BurstMode,
  Toc,
  PictureAsPdf,
  VideoLibrary,
  Remove,
  RemoveCircle,
  Description,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import { getArtists } from "../../../../api/artist";
import {
  changeSupplierArtwork,
  deleteArtwork,
  getArtworkById,
  getArtworks,
  postArtwork,
  updateArtwork,
} from "../../../../api/artwork";
import { getArtworkTypes } from "../../../../api/artworkType";
import { getCountries } from "../../../../api/country";
import { postLog } from "../../../../api/log";
import { getSuppliers } from "../../../../api/supplier";
import { LOGS } from "../../../../utils/constants";
import {
  checkIsEmpty,
  findSimilarArtworks,
  getFileIconByExtension,
  getFileType,
} from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ArtworkTableDialog from "../../../components/dialogs/ArtworkTableDialog";
import CommentDialog from "../../../components/dialogs/CommentDialog";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import FilePickerDialog from "../../../components/dialogs/FilePickerDialog";
import ImageCarouselDialog from "../../../components/dialogs/ImageCarouselDialog";
import ImagePickerDialog from "../../../components/dialogs/ImagePickerDialog";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import SupplierTableDialog from "../../../components/dialogs/SupplierTableDialog";
import ItemCountBadge from "../../../components/ItemCountBadge";
import Table, {
  buttonsStyle,
  substringFormatter,
} from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";
import MyCarousel from "../../../components/carousel/MyCarousel";
import { ar } from "date-fns/esm/locale";
import { FileDropModal } from "../../../components/modal/FileDropModal";
import DeleteIcon from "@material-ui/icons/Delete";
import { getDivisas } from "../../../../api/divisa";
import { getOwners } from "../../../../api/owner";
import OwnerTableDialog from "../../../components/dialogs/OwnerTableDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const useStyles = makeStyles({
  preview: {
    width: 50,
    height: 50,
    objectFit: "cover",
    cursor: "zoom-in",
  },
});

function formatDate(date) {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  const formattedDate = new Date(date).toLocaleString("en-GB", options);
  return formattedDate;
}

export function getEmptyArtwork() {
  return {
    title: "",
    artworkType: "",
    artist: null,
    size: null,
    technique: null,
    year: null,
    imageURL: null,
    signature: null,
    uniqueness: null,
    catalogued: null,
    certified: null,
    color: null,
    provenance: null,
    subject: null,
    artworkSuppliers: [],
    artworkOwners: [],
    filesURLs: [],
    imagesURLs: [],
    videosURLs: [],
  };
}

export default function EditArtworksPage() {
  const [artwork, setArtwork] = useState(getEmptyArtwork());

  const [artworks, setArtworks] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [selectedOwner, setSelectedOwner] = useState({});
  const [artists, setArtists] = useState([]);
  const [artworkTypes, setArtworkTypes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [owners, setOwners] = useState([]);
  const [divisas, setDivisas] = useState([]);
  const [countries, setCountries] = useState([]);
  const [viewOrderImages, setViewOrderImages] = useState(false);
  const [viewOrderVideos, setViewOrderVideos] = useState(false);
  const [viewOrderFiles, setViewOrderFiles] = useState(false);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openSupplierTableDialog, setOpenSupplierTableDialog] = useState(false);
  const [openOwnerTableDialog, setOpenOwnerTableDialog] = useState(false);
  const [openSupplierDateDialog, setOpenSupplierDateDialog] = useState(false);
  const [openOwnerDateDialog, setOpenOwnerDateDialog] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const [selectedArtworks, setSelectedArtworks] = useState([]);
  const [openArtworkTableDialog, setOpenArtworkTableDialog] = useState(false);

  const [selectedArtworkSupplier, setSelectedArtworkSupplier] = useState(null);
  const [selectedArtworkOwner, setSelectedArtworkOwner] = useState(null);

  const [carouselImages, setCarouselImages] = useState([]);
  const [openCarouselDialog, setOpenCarouselDialog] = useState(false);

  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);

  const [openImagePickerDialog, setOpenImagePickerDialog] = useState(false);
  const [openFilePickerDialog, setOpenFilePickerDialog] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImages] = useState(null);

  const [refresh, setRefresh] = useState(null);
  const [refreshOrder, setRefreshOrder] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileType, setFileType] = useState("");

  const artworkId = useParams().id;
  const history = useHistory();
  const location = useLocation();

  const classes = useStyles();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getDivisas().then((res) => {
      setDivisas(res.data);
    });
    getArtworks()
      .then((res) => {
        if (res.status === 200) {
          setArtworks(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artworks.",
        });
        handleBack();
      });
    getArtists()
      .then((res) => {
        if (res.status === 200) {
          setArtists(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artists.",
        });
        handleBack();
      });
    getArtworkTypes()
      .then((res) => {
        if (res.status === 200) {
          setArtworkTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artwork types",
        });
        handleBack();
      });
    getOwners()
      .then((res) => {
        if (res.status === 200) {
          setOwners(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get owners.",
        });
        handleBack();
      });
    getSuppliers()
      .then((res) => {
        if (res.status === 200) {
          setSuppliers(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get suppliers.",
        });
        handleBack();
      });
    getCountries()
      .then((res) => {
        if (res.status === 200) {
          setCountries(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get countries.",
        });
        handleBack();
      });
    if (!artworkId) {
      disableLoadingData();
      return;
    }
    getArtworkById(artworkId)
      .then((res) => {
        if (res.status === 200) {
          setArtwork({ ...artwork, ...res.data });
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artwork.",
        });
        handleBack();
      });
  }, [artworkId, disableLoadingData, history]);

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  const handleBack = (id) => {
    if (!artworkId) history.push(`/artworks/${id}`);
    else history.push(`/artworks/${artworkId}`);
  };

  function handleSaveArtwork() {
    if (checkIsEmpty(artwork.title) || checkIsEmpty(artwork.artworkType)) {
      alertError({ error: "Title and type are required" });
      return;
    }
    const similarArtworks = findSimilarArtworks({
      artworks: artworks,
      artwork: artwork,
    });
    if (similarArtworks?.length > 0) {
      setSelectedArtworks(similarArtworks);
      setOpenArtworkTableDialog(true);
    } else saveArtwork();
  }
  function onSave(files) {
    // Determinar el array base según el tipo de archivo
    let baseArray;
    let updateKey;

    switch (fileType) {
      case "image":
        baseArray = artwork.imagesURLs;
        updateKey = "imagesURLs";
        break;
      case "video":
        baseArray = artwork.videosURLs;
        updateKey = "videosURLs";
        break;
      case "document":
        baseArray = artwork.filesURLs;
        updateKey = "filesURLs";
        break;
      default:
        console.warn("Tipo de archivo no válido:", fileType);
        return;
    }

    let n = baseArray ? baseArray.length : 0;
    const newFiles = files.map((file) => ({
      url: file,
      order: n++,
      _id: n,
    }));

    setArtwork((prev) => ({
      ...prev,
      [updateKey]: [...(prev[updateKey] || []), ...newFiles],
    }));
  }

  async function saveArtwork() {
    if (!artworkId) {
      postArtwork(artwork, selectedImage)
        .then((res) => {
          if (res.status === 201) {
            postLog(
              loggedUser,
              LOGS.FIELDS.ARTWORKS,
              `${LOGS.ACTIONS.CREATE}-${artwork?.title}`
            );
            alertSuccess({
              title: "Saved!",
              customMessage: "Artwork successfully created.",
            });
            handleBack(res.data._id);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save artwork.",
          });
        });
    } else {
      updateArtwork(artworkId, artwork, selectedImage)
        .then((res) => {
          if (res.status === 200) {
            postLog(
              loggedUser,
              LOGS.FIELDS.ARTWORKS,
              `${LOGS.ACTIONS.UPDATE}-${artwork?.title}`
            );
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            handleBack();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setArtwork({ ...artwork, [element]: event.target.value });
  };

  function getArtworkSupplierData(artworkSuppliers) {
    let data = [];
    // console.log("ARTWORK SUPPLIERS", artworkSuppliers);
    for (let i = 0; i < artworkSuppliers?.length; ++i) {
      const elem = {};
      const artworkSupplier = artworkSuppliers[i];

      elem.fullName = suppliers?.find(
        (x) => x._id === artworkSupplier?.supplier
      )?.fullName;
      elem.comments = artworkSupplier?.comments;
      elem.id = artworkSupplier?.supplier;
      elem.date = artworkSupplier?.date
        ? formatDate(artworkSupplier?.date)
        : "N/A";
      elem.multimedia = artworkSupplier?.supplier;

      data = data.concat(elem);
    }
    // console.log("UPDATED DATA", data);
    return data;
  }
  function getArtworkOwnerData(artworkOwners) {
    let data = [];
    // console.log("ARTWORK SUPPLIERS", artworkOwners);
    for (let i = 0; i < artworkOwners?.length; ++i) {
      const elem = {};
      const artworkOwner = artworkOwners[i];

      elem.fullName = owners?.find(
        (x) => x._id === artworkOwner?.owner
      )?.fullName;
      elem.comments = artworkOwner?.comments;
      elem.id = artworkOwner?.owner;
      elem.date = artworkOwner?.date ? formatDate(artworkOwner?.date) : "N/A";
      elem.multimedia = artworkOwner?.owner;

      data = data.concat(elem);
    }
    // console.log("UPDATED DATA", data);
    return data;
  }

  function customDateFormatter(cell, row) {
    return (
      <>
        <Tooltip title={"Date"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedSupplier(row.id);
              setDate(cell);
              setOpenSupplierDateDialog(true);
            }}
          >
            <span>{cell}</span>
            <Create style={{ fontSize: "small" }} />
          </Button>
        </Tooltip>
      </>
    );
  }
  const artworkOwnersColumns = (artworkOwners) => [
    { dataField: "fullName", text: "Full Name", sort: true },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: substringFormatter,
    },
    {
      dataField: "id",
      text: "",
      formatter: (cell) => buttonFormatterOwner(cell, artworkOwners),
    },
  ];

  const artworkSuppliersColumns = (artworkSuppliers) => [
    {
      dataField: "multimedia",
      text: "Multimedia",
      sort: true,
      formatter: multiMediaFormatter,
    },
    { dataField: "fullName", text: "Full Name", sort: true },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      formatter: (cell, row) => customDateFormatter(cell, row),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: substringFormatter,
    },
    {
      dataField: "id",
      text: "",
      formatter: (cell) => buttonFormatter(cell, artworkSuppliers),
    },
  ];
  function imageFormatter(cell, index) {
    const src =
      typeof cell === "string"
        ? `${SERVER_URL}/${cell}`
        : URL.createObjectURL(cell);

    const getType = (url) => {
      const type = typeof url === "string" ? url : url.name;
      return getFileType(type);
    };

    const fileType = getType(cell);

    return cell ? (
      fileType === "video" ? (
        <video
          controls
          style={{ width: "50px", cursor: "zoom-in" }}
          src={src}
        />
      ) : fileType === "image" ? (
        <img
          src={src}
          alt={`Artwork Media ${index}`}
          style={{ width: "50px", cursor: "zoom-in" }}
          onClick={() => {
            setPreviewImages(src);
            setOpenPreviewDialog(2);
          }}
        />
      ) : (
        <div
          onClick={() => window.open(src, "_blank")}
          style={{
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {getFileIconByExtension(
            typeof cell === "string" ? cell.split("/").pop() : cell.name
          )}
          <div
            style={{
              fontSize: "10px",
              textAlign: "center",
              maxWidth: "60px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {typeof cell === "string" ? cell.split("/").pop() : cell.name}
          </div>
        </div>
      )
    ) : (
      <div />
    );
  }
  const columnsMediaImage = [
    {
      dataField: "url",
      text: "",
      formatter: imageFormatter,
      style: { width: "20%" },
      headerStyle: { width: "20%" },
    },
    {
      dataField: "url",
      text: "Name Image",
      formatter: nameFormatter,
      style: { width: "70%" },
      headerStyle: { width: "70%" },
    },
    {
      dataField: "_id",
      text: "",
      formatter: buttonFormatterOrderImage,
      style: { width: "15%" },
      headerStyle: { width: "15%" },
    },
  ];

  const columnsMediaFile = [
    {
      dataField: "url",
      text: "",
      formatter: imageFormatter,
      style: { width: "20%" },
      headerStyle: { width: "20%" },
    },
    {
      dataField: "url",
      text: "Name File",
      formatter: nameFormatter,
      style: { width: "70%" },
      headerStyle: { width: "70%" },
    },
    {
      dataField: "_id",
      text: "",
      formatter: buttonFormatterOrderFile,
      style: { width: "15%" },
      headerStyle: { width: "15%" },
    },
  ];

  const columnsMediaVideo = [
    {
      dataField: "url",
      text: "",
      formatter: imageFormatter,
      style: { width: "20%" },
      headerStyle: { width: "20%" },
    },
    {
      dataField: "url",
      text: "Name Video",
      formatter: nameFormatter,
      style: { width: "70%" },
      headerStyle: { width: "70%" },
    },
    {
      dataField: "_id",
      text: "",
      formatter: buttonFormatterOrderVideo,
      style: { width: "15%" },
      headerStyle: { width: "15%" },
    },
  ];
  function multiMediaFormatterOwner(cell) {
    const elem = artwork.artworkOwners?.find((x) => x.owner === cell);

    // console.log("ELEMENT: ", elem);

    const firstMedia = elem?.imagesURLs?.[0] || elem?.images?.[0];

    const isVideo = (url) => {
      return url
        ? typeof url === "object"
          ? url?.name?.endsWith(".mp4") ||
            url?.name?.endsWith(".webm") ||
            url?.name?.endsWith(".ogg")
          : url?.endsWith(".mp4") ||
            url?.endsWith(".webm") ||
            url?.endsWith(".ogg")
        : false;
    };
    const getMediaSrc = (media) => {
      return typeof media === "string"
        ? SERVER_URL + "/" + media
        : URL.createObjectURL(media);
    };

    return (
      <>
        <Tooltip title={"Media"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setCarouselImages(
                (elem?.imagesURLs || []).concat(elem?.images || [])
              );
              setOpenCarouselDialog(true);
            }}
          >
            {firstMedia ? (
              isVideo(firstMedia) ? (
                <video
                  className={classes.preview}
                  src={getMediaSrc(firstMedia)}
                />
              ) : (
                <img
                  className={classes.preview}
                  src={getMediaSrc(firstMedia)}
                  alt="preview"
                />
              )
            ) : (
              <AddPhotoAlternate />
            )}
            <ItemCountBadge
              howMany={
                (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
              }
            />
          </Button>
        </Tooltip>
      </>
    );
  }

  function multiMediaFormatter(cell) {
    const elem = artwork.artworkSuppliers?.find((x) => x.supplier === cell);

    // console.log("ELEMENT: ", elem);

    const firstMedia = elem?.imagesURLs?.[0] || elem?.images?.[0];

    const isVideo = (url) => {
      return url
        ? typeof url === "object"
          ? url?.name?.endsWith(".mp4") ||
            url?.name?.endsWith(".webm") ||
            url?.name?.endsWith(".ogg")
          : url?.endsWith(".mp4") ||
            url?.endsWith(".webm") ||
            url?.endsWith(".ogg")
        : false;
    };
    const getMediaSrc = (media) => {
      return typeof media === "string"
        ? SERVER_URL + "/" + media
        : URL.createObjectURL(media);
    };

    return (
      <>
        <Tooltip title={"Media"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setCarouselImages(
                (elem?.imagesURLs || []).concat(elem?.images || [])
              );
              setOpenCarouselDialog(true);
            }}
          >
            {firstMedia ? (
              isVideo(firstMedia) ? (
                <video
                  className={classes.preview}
                  src={getMediaSrc(firstMedia)}
                />
              ) : (
                <img
                  className={classes.preview}
                  src={getMediaSrc(firstMedia)}
                  alt="preview"
                />
              )
            ) : (
              <AddPhotoAlternate />
            )}
            <ItemCountBadge
              howMany={
                (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
              }
            />
          </Button>
        </Tooltip>
      </>
    );
  }

  function buttonFormatter(cell, suppliers) {
    const elem = suppliers?.find((x) => x.supplier === cell);

    return (
      <>
        <Tooltip title={!elem?.comments ? "Add comments" : "Edit comments"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenCommentDialog(1);
              setSelectedArtworkSupplier(elem);
            }}
          >
            {!elem?.comments ? <AddComment /> : <RateReview />}
            {elem?.comments && <ItemCountBadge howMany={1} />}
          </Button>
        </Tooltip>
        <Tooltip
          title={
            !elem?.imagesURLs?.length > 0 && !elem?.images?.length > 0
              ? "Add Images"
              : "Edit Images"
          }
        >
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenImagePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <AddPhotoAlternate />
            {(elem?.imagesURLs?.length > 0 || elem?.images?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip
          title={
            !elem?.filesURLs?.length > 0 && !elem?.files?.length > 0
              ? "Add documentation"
              : "Edit documentation"
          }
        >
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenFilePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <NoteAdd />
            {(elem?.filesURLs?.length > 0 || elem?.files?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.filesURLs?.length || 0) + (elem?.files?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip title={"See supplier"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push("/suppliers/" + elem?.supplier + "/edit");
            }}
          >
            <Launch />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              let artworkSuppliers = [...artwork.artworkSuppliers];
              artworkSuppliers = artworkSuppliers.filter(
                (x, index) => x.supplier !== cell
              );
              setArtwork({
                ...artwork,
                artworkSuppliers: artworkSuppliers,
              });
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
      </>
    );
  }

  function buttonFormatterOwner(cell, owners) {
    const elem = owners?.find((x) => x.owner === cell);

    return (
      <>
        <Tooltip title={!elem?.comments ? "Add comments" : "Edit comments"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenCommentDialog(2);
              setSelectedArtworkOwner(elem);
            }}
          >
            {!elem?.comments ? <AddComment /> : <RateReview />}
            {elem?.comments && <ItemCountBadge howMany={1} />}
          </Button>
        </Tooltip>
        {/* <Tooltip
          title={
            !elem?.imagesURLs?.length > 0 && !elem?.images?.length > 0
              ? "Add Images"
              : "Edit Images"
          }
        >
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenImagePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <AddPhotoAlternate />
            {(elem?.imagesURLs?.length > 0 || elem?.images?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip
          title={
            !elem?.filesURLs?.length > 0 && !elem?.files?.length > 0
              ? "Add documentation"
              : "Edit documentation"
          }
        >
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenFilePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <NoteAdd />
            {(elem?.filesURLs?.length > 0 || elem?.files?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.filesURLs?.length || 0) + (elem?.files?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip> */}
        <Tooltip title={"See owner"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push("/owners/" + elem?.owner + "/edit");
            }}
          >
            <Launch />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              let artworkOwners = [...artwork.artworkOwners];
              artworkOwners = artworkOwners.filter(
                (x, index) => x.owner !== cell
              );
              setArtwork({
                ...artwork,
                artworkOwners: artworkOwners,
              });
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
      </>
    );
  }

  function handleDeleteMedia(selectedType, selectedMediaId) {
    let baseArray;
    let updateKey;
    switch (selectedType) {
      case "image":
        baseArray = artwork.imagesURLs;
        updateKey = "imagesURLs";
        break;
      case "video":
        baseArray = artwork.videosURLs;
        updateKey = "videosURLs";
        break;
      case "file":
        baseArray = artwork.filesURLs;
        updateKey = "filesURLs";
        break;
      default:
        console.warn("Tipo de archivo no válido:", selectedType);
        return;
    }

    // Encontrar el elemento que se va a eliminar para obtener su orden
    const elementToDelete = baseArray.find(
      (item) => item._id === selectedMediaId
    );

    if (!elementToDelete) {
      console.warn("Elemento no encontrado:", selectedMediaId);
      return;
    }

    const deletedOrder = elementToDelete.order;

    // Filtrar el elemento a eliminar
    const filteredArray = baseArray.filter(
      (item) => item._id !== selectedMediaId
    );

    // Actualizar el orden de los elementos restantes
    const updatedArray = filteredArray.map((item) => {
      if (item.order > deletedOrder) {
        return {
          ...item,
          order: item.order - 1,
        };
      }
      return item;
    });

    // Actualizar el estado
    setArtwork((prev) => ({
      ...prev,
      [updateKey]: updatedArray,
    }));
    setRefreshOrder(true);
  }
  function buttonFormatterOrderImage(cell) {
    const elem = artwork.imagesURLs.find((x) => x._id === cell);

    const handleSubtract = () => {
      setArtwork((prevArtwork) => {
        const currentImage = prevArtwork.imagesURLs.find(
          (img) => img._id === cell
        );
        if (!currentImage || currentImage.order === 0) return prevArtwork;

        const newOrder = currentImage.order - 1;
        const imageToSwap = prevArtwork.imagesURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          imagesURLs: prevArtwork.imagesURLs.map((image) => {
            if (image._id === cell) {
              return { ...image, order: newOrder };
            }
            if (imageToSwap && image._id === imageToSwap._id) {
              return { ...image, order: currentImage.order };
            }
            return image;
          }),
        };
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setArtwork((prevArtwork) => {
        const currentImage = prevArtwork.imagesURLs.find(
          (img) => img._id === cell
        );
        if (
          !currentImage ||
          currentImage.order === prevArtwork.imagesURLs.length - 1
        )
          return prevArtwork;

        const newOrder = currentImage.order + 1;
        const imageToSwap = prevArtwork.imagesURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          imagesURLs: prevArtwork.imagesURLs.map((image) => {
            if (image._id === cell) {
              return { ...image, order: newOrder };
            }
            if (imageToSwap && image._id === imageToSwap._id) {
              return { ...image, order: currentImage.order };
            }
            return image;
          }),
        };
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === artwork?.imagesURLs?.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title={"Delete"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => handleDeleteMedia("image", cell)}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  function buttonFormatterOrderVideo(cell) {
    const elem = artwork.videosURLs.find((x) => x._id === cell);

    const handleSubtract = () => {
      setArtwork((prevArtwork) => {
        const currentViedo = prevArtwork.videosURLs.find(
          (img) => img._id === cell
        );
        if (!currentViedo || currentViedo.order === 0) return prevArtwork;

        const newOrder = currentViedo.order - 1;
        const videoToSwap = prevArtwork.videosURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          videosURLs: prevArtwork.videosURLs.map((video) => {
            if (video._id === cell) {
              return { ...video, order: newOrder };
            }
            if (videoToSwap && video._id === videoToSwap._id) {
              return { ...video, order: currentViedo.order };
            }
            return video;
          }),
        };
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setArtwork((prevArtwork) => {
        const currentVideo = prevArtwork.videosURLs.find(
          (img) => img._id === cell
        );
        if (
          !currentVideo ||
          currentVideo.order === prevArtwork.videosURLs.length - 1
        )
          return prevArtwork;

        const newOrder = currentVideo.order + 1;
        const videoToSwap = prevArtwork.videosURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          videosURLs: prevArtwork.videosURLs.map((video) => {
            if (video._id === cell) {
              return { ...video, order: newOrder };
            }
            if (videoToSwap && video._id === videoToSwap._id) {
              return { ...video, order: currentVideo.order };
            }
            return video;
          }),
        };
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === artwork?.videosURLs?.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title={"Delete"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => handleDeleteMedia("video", cell)}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  function buttonFormatterOrderFile(cell) {
    const elem = artwork.filesURLs.find((x) => x._id === cell);

    const handleSubtract = () => {
      setArtwork((prevArtwork) => {
        const currentFile = prevArtwork.filesURLs.find(
          (img) => img._id === cell
        );
        if (!currentFile || currentFile.order === 0) return prevArtwork;

        const newOrder = currentFile.order - 1;
        const fileToSwap = prevArtwork.filesURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          filesURLs: prevArtwork.filesURLs.map((file) => {
            if (file._id === cell) {
              return { ...file, order: newOrder };
            }
            if (fileToSwap && file._id === fileToSwap._id) {
              return { ...file, order: currentFile.order };
            }
            return file;
          }),
        };
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setArtwork((prevArtwork) => {
        const currentFile = prevArtwork.filesURLs.find(
          (img) => img._id === cell
        );
        if (
          !currentFile ||
          currentFile.order === prevArtwork.filesURLs.length - 1
        )
          return prevArtwork;

        const newOrder = currentFile.order + 1;
        const fileToSwap = prevArtwork.filesURLs.find(
          (img) => img.order === newOrder
        );

        return {
          ...prevArtwork,
          filesURLs: prevArtwork.filesURLs.map((file) => {
            if (file._id === cell) {
              return { ...file, order: newOrder };
            }
            if (fileToSwap && file._id === fileToSwap._id) {
              return { ...file, order: currentFile.order };
            }
            return file;
          }),
        };
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === artwork?.filesURLs?.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title={"Delete"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => handleDeleteMedia("file", cell)}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  function nameFormatter(cell) {
    const name = typeof cell === "string" ? cell.split("/").pop() : cell.name;
    return name;
  }

  function ordenarData(lista) {
    return [...lista].sort((a, b) => a.order - b.order);
  }
  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  const colorOptions = [
    { label: "Red", value: "red", colorCode: "#FF0000" },
    { label: "Green", value: "green", colorCode: "#00FF00" },
    { label: "Yellow", value: "yellow", colorCode: "#FFFF00" },
  ];

  const uniquenessOptions = [
    { label: "Original", value: "Original" },
    { label: "Edition", value: "Edition" },
  ];

  const handlerOpenUploadImage = () => {
    setFileType("image");
    setIsModalOpen(true);
  };
  const handlerOpenUploadVideo = () => {
    setFileType("video");
    setIsModalOpen(true);
  };
  const handlerOpenUploadDocument = () => {
    setFileType("document");
    setIsModalOpen(true);
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Edit artwork">
            <CardHeaderToolbar>
              <Button
                onClick={() => handleSaveArtwork()}
                variant="outlined"
                color="primary"
              >
                Save artwork
              </Button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-4">
                <CardMaterial>
                  <CardMedia
                    component="img"
                    alt="Artwork"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "auto",
                      maxHeight: "600px",
                    }}
                    image={
                      selectedImage
                        ? URL.createObjectURL(selectedImage)
                        : `${SERVER_URL}/${artwork.imageURL}`
                    }
                  />
                </CardMaterial>
                <label htmlFor={"upload-media"} className="ml-0 my-4">
                  <input
                    style={{ display: "none" }}
                    id={"upload-media"}
                    name={"upload-media"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                      setSelectedImage(e.target.files[0]);
                    }}
                  />
                  <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                  >
                    {selectedImage ||
                    (artwork.imageURL && artwork.imageURL !== "")
                      ? "Change media"
                      : "Upload media"}
                  </Button>
                </label>
                {(selectedImage ||
                  (artwork.imageURL && artwork.imageURL !== "")) && (
                  <>
                    <Tooltip title={"Preview"}>
                      <Button
                        size="small"
                        onClick={() => setOpenPreviewDialog(1)}
                        style={{
                          ...buttonsStyle,
                          marginRight: "15px",
                        }}
                      >
                        <Visibility />
                      </Button>
                    </Tooltip>
                    <PreviewDialog
                      title={"Preview"}
                      open={openPreviewDialog === 1}
                      setOpen={setOpenPreviewDialog}
                      file={selectedImage}
                      src={
                        selectedImage
                          ? URL.createObjectURL(selectedImage)
                          : `${SERVER_URL}/${artwork.imageURL}`
                      }
                    />
                    <PreviewDialog
                      title={"Preview"}
                      open={openPreviewDialog === 2}
                      setOpen={setOpenPreviewDialog}
                      file={previewImage}
                      src={`${SERVER_URL}/${previewImage}`}
                    />
                    <Tooltip title={"Delete"}>
                      <Button
                        size="small"
                        onClick={() => {
                          setSelectedImage(null);
                          setArtwork({
                            ...artwork,
                            imageURL: null,
                          });
                        }}
                      >
                        <Delete />
                      </Button>
                    </Tooltip>
                  </>
                )}
              </div>
              <div className="col-md-4">
                <Autocomplete
                  id="autocomplete-color"
                  disablePortal
                  options={colorOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    colorOptions.find((x) => x.value === artwork.color) || ""
                  }
                  onChange={(event, selected) => {
                    setArtwork({
                      ...artwork,
                      color: selected ? selected.value : null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Color"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <Box
                            style={{
                              width: 20,
                              height: 20,
                              borderRadius: "50%",
                              backgroundColor: params.inputProps.value
                                ? colorOptions.find(
                                    (x) => x.label === params.inputProps.value
                                  )?.colorCode
                                : "transparent",
                              marginRight: 8,
                            }}
                          />
                        ),
                      }}
                    />
                  )}
                  renderOption={(option) => (
                    <Box display="flex" alignItems="center">
                      <Box
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          backgroundColor: option.colorCode,
                          marginRight: 8,
                        }}
                      />
                      {option.label}
                    </Box>
                  )}
                />
                <Autocomplete
                  id="autocomplete-artist"
                  disablePortal
                  options={artists}
                  getOptionLabel={(option) => option.fullName}
                  value={artists?.find((x) => x._id === artwork?.artist) || ""}
                  onChange={(event, selected) => {
                    setArtwork({
                      ...artwork,
                      artist: selected ? selected._id : null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Artist"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
                <TextField
                  id={`fullName`}
                  label="Title"
                  value={artwork.title}
                  onChange={handleChange("title")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
                <Autocomplete
                  id="autocomplete-uniqueness"
                  disablePortal
                  options={uniquenessOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    uniquenessOptions.find(
                      (x) => x.value === artwork.uniqueness
                    ) || ""
                  }
                  onChange={(event, selected) => {
                    setArtwork({
                      ...artwork,
                      uniqueness: selected ? selected.value : null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Uniqueness"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
                <Autocomplete
                  id="autocomplete-artworkType"
                  disablePortal
                  disableClearable
                  options={artworkTypes}
                  getOptionLabel={(option) => option.title}
                  value={
                    artworkTypes?.find((x) => x._id === artwork?.artworkType) ||
                    ""
                  }
                  onChange={(event, selected) => {
                    setArtwork({
                      ...artwork,
                      artworkType: selected ? selected._id : null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Artwork Type"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
                <TextField
                  id={`price`}
                  label="Price"
                  value={artwork.price}
                  onChange={handleChange("price")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <TextField
                  id={`size`}
                  label="Size"
                  value={artwork.size}
                  onChange={handleChange("size")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  id={`technique`}
                  label="Technique"
                  value={artwork.technique}
                  onChange={handleChange("technique")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  id={`year`}
                  label="Year"
                  value={artwork.year}
                  onChange={handleChange("year")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  id={`signature`}
                  label="Signature"
                  value={artwork.signature}
                  onChange={handleChange("signature")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  id={`catalogued`}
                  label="Catalogued"
                  value={artwork.catalogued}
                  onChange={handleChange("catalogued")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  id={`certified`}
                  label="Certified"
                  value={artwork.certified}
                  onChange={handleChange("certified")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <br />
            <br />
            <TextField
              id="recentAuctions"
              label="Recent Auctions"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={artwork.recentAuctions}
              onChange={handleChange("recentAuctions")}
            />
            <br />
            <br />
            <TextField
              id="provenance"
              label="Notas"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={artwork.provenance}
              onChange={handleChange("provenance")}
            />
          </CardBody>

          <CardBody>
            <section
              className="d-flex flex-row justify-content-end"
              style={{ marginRight: "50px" }}
            >
              <IconButton
                onClick={() => setViewOrderImages(false)}
                aria-label="List View"
              >
                {viewOrderImages ? (
                  <BurstMode />
                ) : (
                  <BurstMode style={{ color: "Black" }} />
                )}
              </IconButton>
              <IconButton
                onClick={() => setViewOrderImages(true)}
                aria-label="Calendar View"
              >
                {viewOrderImages ? <Toc style={{ color: "Black" }} /> : <Toc />}
              </IconButton>
            </section>

            {viewOrderImages ? (
              <>
                {artwork?.imagesURLs?.length > 0 && !refreshOrder && (
                  <Table
                    columns={columnsMediaImage}
                    data={ordenarData(artwork?.imagesURLs)}
                  />
                )}
              </>
            ) : (
              <>
                <div className="d-flex">
                  <div className="col-12">
                    <MyCarousel
                      lista={artwork?.imagesURLs}
                      handleOpenUpload={handlerOpenUploadImage}
                      nameFile={"images.zip"}
                    />
                  </div>
                </div>
              </>
            )}
            <section
              className="d-flex flex-row justify-content-end"
              style={{ marginRight: "50px" }}
            >
              <IconButton
                onClick={() => setViewOrderVideos(false)}
                aria-label="List View"
              >
                {viewOrderVideos ? (
                  <VideoLibrary />
                ) : (
                  <VideoLibrary style={{ color: "Black" }} />
                )}
              </IconButton>
              <IconButton
                onClick={() => setViewOrderVideos(true)}
                aria-label="Calendar View"
              >
                {viewOrderVideos ? <Toc style={{ color: "Black" }} /> : <Toc />}
              </IconButton>
            </section>
            {viewOrderVideos ? (
              <>
                {artwork?.videosURLs?.length > 0 && !refreshOrder && (
                  <>
                    <Table
                      columns={columnsMediaVideo}
                      data={ordenarData(artwork?.videosURLs)}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <div className="d-flex">
                  <div className="col-md-12">
                    <MyCarousel
                      lista={artwork?.videosURLs}
                      handleOpenUpload={handlerOpenUploadVideo}
                      nameFile={"videos.zip"}
                    />
                  </div>
                </div>
              </>
            )}
            <section
              className="d-flex flex-row justify-content-end"
              style={{ marginRight: "50px" }}
            >
              <IconButton
                onClick={() => setViewOrderFiles(false)}
                aria-label="List View"
              >
                {viewOrderFiles ? (
                  <PictureAsPdf />
                ) : (
                  <PictureAsPdf style={{ color: "Black" }} />
                )}
              </IconButton>
              <IconButton
                onClick={() => setViewOrderFiles(true)}
                aria-label="Calendar View"
              >
                {viewOrderFiles ? <Toc style={{ color: "Black" }} /> : <Toc />}
              </IconButton>
            </section>
            {viewOrderFiles ? (
              <>
                {artwork?.filesURLs?.length > 0 && !refreshOrder && (
                  <Table
                    columns={columnsMediaFile}
                    data={ordenarData(artwork?.filesURLs)}
                  />
                )}
              </>
            ) : (
              <>
                <div className="d-flex">
                  <div className="col-md-12">
                    <MyCarousel
                      lista={artwork?.filesURLs}
                      handleOpenUpload={handlerOpenUploadDocument}
                      nameFile={"files.zip"}
                      carruselDocs={true}
                    />
                  </div>
                </div>
              </>
            )}
          </CardBody>
          <CardHeader title="Suppliers" sticky={false}>
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpenSupplierTableDialog(true);
                }}
              >
                Add new
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {artwork?.artworkSuppliers?.length > 0 && !refresh && (
              <Table
                data={getArtworkSupplierData(artwork?.artworkSuppliers)}
                columns={artworkSuppliersColumns(artwork?.artworkSuppliers)}
              />
            )}
          </CardBody>
          <CardHeader title="Owners" sticky={false}>
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpenOwnerTableDialog(true);
                }}
              >
                Add new
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {artwork?.artworkOwners?.length > 0 && !refresh && (
              <>
                <Table
                  data={getArtworkOwnerData(artwork?.artworkOwners)}
                  columns={artworkOwnersColumns(artwork?.artworkOwners)}
                />
              </>
            )}
          </CardBody>
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => handleSaveArtwork()}
          variant="outlined"
          color="primary"
          style={artworkId && { marginRight: "20px" }}
        >
          Save artwork
        </Button>
        {artworkId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                className="py-2"
                onClick={() => setOpenConfirmDialog(1)}
                variant="outlined"
                color="secondary"
              >
                Delete artwork
              </Button>
            </MuiThemeProvider>
            <ConfirmDialog
              title={"Are you sure you want to delete this artwork?"}
              open={openConfirmDialog === 1}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteArtwork(artworkId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      postLog(
                        loggedUser,
                        LOGS.FIELDS.ARTWORKS,
                        `${LOGS.ACTIONS.DELETE}-${artwork?.title}`
                      );
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Artwork deleted successfully.",
                      });
                      handleBack();
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete artwork.",
                    });
                  });
              }}
            />
          </>
        )}
        <SupplierTableDialog
          title="Suppliers"
          open={openSupplierTableDialog}
          setOpen={setOpenSupplierTableDialog}
          data={suppliers.filter(
            (x) => !artwork?.artworkSuppliers?.some((y) => y.supplier === x._id)
          )}
          onSelectRow={(supplierId) => {
            console.log("SUPPLIER ID", supplierId);
            let artworkSuppliers = artwork.artworkSuppliers;
            artworkSuppliers.push({ supplier: supplierId });

            setOpenSupplierDateDialog(true);
            setSelectedSupplier(supplierId);
            setArtwork({ ...artwork, artworkSuppliers: artworkSuppliers });
          }}
        />

        <OwnerTableDialog
          title="Owners"
          open={openOwnerTableDialog}
          setOpen={setOpenOwnerTableDialog}
          data={owners.filter(
            (x) => !artwork?.artworkOwners?.some((y) => y.owner === x._id)
          )}
          onSelectRow={(ownerId) => {
            console.log("OWNER ID", ownerId);
            let artworkOwners = artwork.artworkOwners;
            artworkOwners.push({ owner: ownerId });
            // setOpenOwnerDateDialog(true);
            setSelectedOwner(ownerId);
            setArtwork({ ...artwork, artworkOwners: artworkOwners });
          }}
        />

        <Modal
          open={openSupplierDateDialog}
          onClose={() => setOpenSupplierDateDialog(false)}
          aria-labelledby="supplier-date-dialog"
          aria-describedby="Date dialog for a supplier"
        >
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width={400}
            bgcolor="background.paper"
            border="2px solid #000"
            boxShadow={24}
            p={4}
          >
            <Typography id="supplier-date-dialog" variant="h6">
              Supplier Date
            </Typography>
            <TextField
              id="date"
              label="Date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              margin="normal"
            />
            <Button
              variant="contained"
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const updatedArtworkSuppliers = [...artwork.artworkSuppliers];

                const index = updatedArtworkSuppliers.findIndex(
                  (x) => x.supplier === selectedSupplier
                );

                if (index !== -1) {
                  updatedArtworkSuppliers[index] = {
                    ...updatedArtworkSuppliers[index],
                    date: date,
                  };

                  setArtwork({
                    ...artwork,
                    artworkSuppliers: updatedArtworkSuppliers,
                  });
                }

                setOpenSupplierDateDialog(false);
              }}
            >
              Save
            </Button>
          </Box>
        </Modal>
        <Modal
          open={openOwnerDateDialog}
          onClose={() => setOpenOwnerDateDialog(false)}
          aria-labelledby="owner-date-dialog"
          aria-describedby="Date dialog for a owner"
        >
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width={400}
            bgcolor="background.paper"
            border="2px solid #000"
            boxShadow={24}
            p={4}
          >
            <Typography id="owner-date-dialog" variant="h6">
              Owner Date
            </Typography>
            <TextField
              id="date"
              label="Date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              margin="normal"
            />
            <Button
              variant="contained"
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const updatedArtworkOwners = [...artwork.artworkOwners];

                const index = updatedArtworkOwners.findIndex(
                  (x) => x.owner === selectedOwner
                );

                if (index !== -1) {
                  updatedArtworkOwners[index] = {
                    ...updatedArtworkOwners[index],
                    date: date,
                  };

                  setArtwork({
                    ...artwork,
                    artworkOwners: updatedArtworkOwners,
                  });
                }

                setOpenOwnerDateDialog(false);
              }}
            >
              Save
            </Button>
          </Box>
        </Modal>
        <CommentDialog
          title={"Additional Comments"}
          open={openCommentDialog === 1}
          setOpen={setOpenCommentDialog}
          data={selectedArtworkSupplier?.comments}
          onSave={(comments) => {
            let artworkSuppliers = [...artwork.artworkSuppliers];

            let index = artworkSuppliers.findIndex(
              (x) => x.supplier === selectedArtworkSupplier?.supplier
            );
            artworkSuppliers[index] = {
              ...artworkSuppliers[index],
              comments: comments,
            };

            setArtwork({
              ...artwork,
              artworkSuppliers: artworkSuppliers,
            });

            setRefresh(true);
          }}
        />
        <CommentDialog
          title={"Additional Comments"}
          open={openCommentDialog === 2}
          setOpen={setOpenCommentDialog}
          data={selectedArtworkOwner?.comments}
          onSave={(comments) => {
            let artworkOwners = [...artwork.artworkOwners];

            let index = artworkOwners.findIndex(
              (x) => x.owner === selectedArtworkOwner?.owner
            );
            artworkOwners[index] = {
              ...artworkOwners[index],
              comments: comments,
            };

            setArtwork({
              ...artwork,
              artworkOwners: artworkOwners,
            });

            setRefresh(true);
          }}
        />
        <ImagePickerDialog
          title={"Images"}
          open={openImagePickerDialog}
          setOpen={setOpenImagePickerDialog}
          data={[
            ...(selectedArtworkSupplier?.imagesURLs ?? []),
            ...(selectedArtworkSupplier?.images ?? []),
          ]}
          onSave={(images) => {
            let artworkSuppliers = [...artwork.artworkSuppliers];

            let index = artworkSuppliers.findIndex(
              (x) => x.supplier === selectedArtworkSupplier?.supplier
            );
            artworkSuppliers[index] = {
              ...artworkSuppliers[index],
              images: images?.filter((x) => x.name),
              imagesURLs: images?.filter((x) => !x.name),
            };

            setArtwork({
              ...artwork,
              artworkSuppliers: artworkSuppliers,
            });
            setRefresh(true);
          }}
        />
        <FilePickerDialog
          title={"Archivos"}
          open={openFilePickerDialog}
          setOpen={setOpenFilePickerDialog}
          data={[
            ...(selectedArtworkSupplier?.filesURLs ?? []),
            ...(selectedArtworkSupplier?.files ?? []),
          ]}
          onSave={(files) => {
            let artworkSuppliers = [...artwork.artworkSuppliers];

            let index = artworkSuppliers.findIndex(
              (x) => x.supplier === selectedArtworkSupplier?.supplier
            );
            artworkSuppliers[index] = {
              ...artworkSuppliers[index],
              files: files?.filter((x) => x.name),
              filesURLs: files?.filter((x) => !x.name),
            };

            setArtwork({
              ...artwork,
              artworkSuppliers: artworkSuppliers,
            });

            setRefresh(true);
          }}
        />
        <ImageCarouselDialog
          open={openCarouselDialog}
          setOpen={setOpenCarouselDialog}
          images={carouselImages}
        />
        <ArtworkTableDialog
          title={"Similar Artworks: " + artwork?.title}
          subtitle={
            <div className="bg-danger text-white p-3 mb-4">
              There are some artworks that have similar features! Check them
              before saving.
            </div>
          }
          open={openArtworkTableDialog}
          setOpen={setOpenArtworkTableDialog}
          data={selectedArtworks}
          allowAdd={false}
          onSave={() => saveArtwork()}
        />
        <ConfirmDialog
          title={"Are you sure you want to select this supplier?"}
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeSupplierArtwork(artworkId, selectedOwner)
              .then((res) => {
                if (res.status === 200) {
                  postLog(
                    loggedUser,
                    LOGS.FIELDS.ARTWORKS,
                    `${LOGS.ACTIONS.OWNER}-${artwork?.title}`
                  );
                  alertSuccess({
                    title: "Changed!",
                    customMessage: "Supplier Changed successfully.",
                  });
                  setRefresh(true);
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "Could not change supplier.",
                });
              });
          }}
        />
        <FileDropModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          fileType={fileType}
          onSave={onSave}
        />
      </>
    );
}
